import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {CashDesk, Ticket, TicketCashDesk} from '../Model'
import {T} from 'helpers/i18n'
import {toMoney, toPercentage, toDateTime, toRound, toPorciento, toDate} from 'helpers/Format'
import TicketsReport from '../components/TicketsReport'
import {User} from '../../Users/Model'
import history from 'helpers/History'
import Theme from 'Theme'
import {Button, Card, CardBody, CardHeader, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap'
import QRCodeSVG from '../../../elements/QRCode'
import {tramoHora} from './TicketSales'

interface Props {
  store?: Store
}

@inject('store')
@observer
class TicketDetail extends PureComponent<Props, object> {
  users: User[]

  UNSAFE_componentWillMount() {
    console.log('UNSAFE_componentWillMount')
    if ( history.location.state === undefined ) {
      history.goBack()
    }
  }

  componentDidMount() {
    console.log('TicketGratis - componentDidMount')
    this.props.store!.reports.readTicketGratis()
  }

  findUser = (lista, id: number) => {
    const result = lista.find(value => value.id === id)
    return result ? result.name : ''
  }

  handleOnSelectItem = (item) => {
    console.error((item as any).id)
  }

  toggle = () => {
    history.goBack()
  }

  render() {
    const item: Ticket | any = history.location.state
    console.log('item: ', item)
    const {reports} = this.props.store!
    const headers = ['businessUnit', 'operationLine', 'stretch', 'numero', 'user', 'datecheck', 'terminal', 'netAmount', 'taxAmount', 'discount', 'total']
    const items = reports.ticketGratis
    const image =`${process.env.REACT_APP_SERVER}${item.image}`
    console.log('item.daterefund', item.daterefund)
    const canceled = !!item.daterefund
    console.log('canceled', canceled)

    const externalCloseBtn =
      <button
        className="close"
        style={{ color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px', }}
        onClick={this.toggle}>
        &times;
      </button>;

    return (
      <div className="animated fadeIn" >
        <Row>
          <Col>
            <Modal
              centered
              fade
              isOpen={true}
              modalTransition={{ timeout: 700 }}
              backdropTransition={{ timeout: 1000 }}
              toggle={this.toggle}
              /*external={externalCloseBtn}*/
              style={{width: '320px'}}
            >
              <ModalHeader>{`Ticket ${item.id} - ${item.numero}`}</ModalHeader>
              <ModalBody>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  <img alt={'image'} width={'130px'} src={image} />
                  <p style={{margin: 0}}>
                    {item.username}
                  </p>
                  <p>
                    {toDateTime(item.datecheck)}
                  </p>
                  <h3>
                    RECIBO
                  </h3>
                  <p style={{
                    marginTop: '10px',
                    width: '100%',
                    height: '1px',
                    background: 'black',
                  }}
                  >
                    {''}
                  </p>
                  <div style={{
                    width: '275px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'flex-start'
                  }}>
                    <p style={{marginBottom: '1px'}}>
                      {item.operationLine}
                    </p>
                    <p style={{marginTop: '1px'}}>
                      {item.stretch}
                    </p>
                  </div>

                  <p style={{
                    width: '100%',
                    height: '1px',
                    background: 'black',
                  }}
                  >
                    {''}
                  </p>
                  {item.lines.map( line =>
                    <div key={line.id} style={{
                      width: '275px',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                    }}>
                      <p style={{width: '60px', }}>{`${line.quantity}x`}</p>
                      <p style={{width: '120px', }}>{line.passengerCategoryName}</p>
                      <p style={{ textAlign: 'end', width: '100px', }}>{toRound(line.total)}</p>
                    </div>
                  )}
                  <p style={{
                    marginBottom: '5px',
                    width: '100%',
                    height: '1px',
                    background: 'black',
                  }}
                  >
                    {''}
                  </p>
                  <div style={{
                    width: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                  }}>
                    {item.discount > 0 &&
                      <div>
                        <p style={{ margin: '0', padding: 0, textDecoration: 'line-through', fontWeight: 'normal', textAlign: 'end' }}>{`Total  ${toRound(item.taxAmount + item.netAmount)} EUR`}</p>
                        <p style={{ margin: '0', padding: 0, textAlign: 'end' }}>{`Descuento: ${item.discount} %`}</p>
                      </div>
                    }
                    <p style={{ textDecoration: canceled?'line-through': 'initial', margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end'}}>{`Total  ${toRound(item.total)}EUR`}</p>
                    {canceled && <p style={{ margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end'}}>{T('canceled')}</p>}
                  </div>
                  <p style={{ textAlign: 'end', width: '100%', }}>{`Iva Incluido - ${item.tin}`}</p>
                  <span>{`${item.numero}`}</span>
                  <QRCodeSVG value={item.numero} size={100} level={'H'}/>
                  <p style={{ marginTop: '10px' }}>Gracias por su visita</p>
                  <p style={{marginBottom: 0}}>{'**********************************************'}</p>
                  {/*{(item.vuelta || item.hoponHopoff) &&
                    <p style={{marginBottom: 0}}>{'**********************************************'}</p>
                  }*/}
                  {renderExpiration(item)}
                  {item.vuelta && !item.hoponHopoff && renderIdaVuelta()}
                  {!item.daterefund && item.datevalited && item.numberScanned === 1 && <img
                    style={{position: 'absolute', top: '70%', left: '69%'}}
                    alt={'image'} width={'90x'}
                    src={'/assets/images/valited.jpeg'}
                  />}
                  {!item.daterefund && item.datevalited && item.numberScanned === 2 &&
                    <div>
                      <img
                      style={{position: 'absolute', top: '83%', left: '69%'}}
                      alt={'image'} width={'90px'}
                      src={'/assets/images/valited.jpeg'}
                    />
                    <img
                      style={{position: 'absolute', top: '90%', left: '65%'}}
                      alt={'image'} width={'90px'}
                      src={'/assets/images/valited.jpeg'}
                    />
                  </div>}
                </div>
              </ModalBody>
            </Modal>
          </Col>
        </Row>
      </div>
    )
  }
}

const renderExpiration = (item: Ticket) => {
  const {timeExpiration} = item
  console.log('dateExpiration', timeExpiration)
  const expiration = new Date(item.datebook)
  expiration.setHours(23, 59, 59, 999)
  expiration.setDate(expiration.getDate() + timeExpiration)

  if (item.tramoHora) {
    const tramoHorario = tramoHora(item.datebook)
    return (
      <div style={{marginTop: 0}}>
        {!item.vuelta &&<h6 ><p style={{textAlign: 'center'}}>{'Válido para un solo uso'}</p></h6>}
        {item.vuelta && <h6 ><p style={{textAlign: 'center'}}>{'Válido para un solo uso de ida y vuelta'}</p></h6>}
        <h6 ><p style={{marginTop:0, marginBottom:0, textAlign: 'center'}}>{toDate(item.datebook)} a las {tramoHorario} horas</p></h6>
      </div>
    )
  } else {
    return (
      <div style={{marginTop: 0}}>
        {item.hoponHopoff && <h2 ><p style={{textAlign: 'center'}}>{'HopON HopOFF'}</p></h2>}
        {!item.hoponHopoff && !item.vuelta && <h6 ><p style={{textAlign: 'center'}}>{'Válido para un solo uso'}</p></h6>}
        {!item.hoponHopoff && item.vuelta && <h6 ><p style={{textAlign: 'center'}}>{'Válido para un solo uso de ida y vuelta'}</p></h6>}
        {fechasIguales(item.datebook, expiration) && <h6 ><p style={{marginTop:0, marginBottom:0, textAlign: 'center'}}>{T('parael')} {toDate(expiration)}</p></h6>}
        {!fechasIguales(item.datebook, expiration) && <h6 ><p style={{marginTop:0, marginBottom:0, textAlign: 'center'}}>{T('desde')} {toDate(item.datebook)} {T('hasta')} {toDate(expiration)}</p></h6>}
      </div>
    )
  }

}

const renderIdaVuelta = () => {
  return (
    <div>
      <h2><p style={{marginTop:0, marginBottom:0, textAlign: 'center'}}>{'IDA'}</p></h2>
      <h2><p  style={{textAlign: 'center'}}>{'VUELTA'}</p></h2>
    </div>
  )
}

const fechasIguales = (date1: Date, date2: Date) => {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
}
export default TicketDetail



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/TicketDetail.tsx